import React from "react";
import { Input, type InputProps } from "semantic-ui-react";

interface Props extends InputProps {
  errorMessage?: string
}

const InputWithError = (props: Props) => {
  const { errorMessage, ...rest } = props;

  const hasErrorMessage = !!errorMessage;

  return <>
    <Input error={hasErrorMessage || rest.error} {...rest} />

    {hasErrorMessage && <div className="s1_warning">
      {errorMessage}
    </div>}
  </>;
};

export default InputWithError;
